<template>
  <header class="w-full bg-base-100 bg-purple-300">
    <nav class="container mx-auto px-4 py-2">
      <div class="flex flex-wrap items-center justify-between">
        <!-- Logo and website title -->
        <div class="flex items-center space-x-3">
          <img src="./../assets/wurfllogo.png" alt="WURFL logo" width="47" height="47"  class="w-10 h-10" />
          <span class="text-lg font-semibold">WURFL Query API: Demo Dashboard</span>
        </div>

        <!-- Search form -->
        <form @submit.prevent="submitform" class="d-flex items-center w-full md:w-auto">
          <input class="input input-bordered w-full md:w-60 md:mr-2"  :class="[formdata.model_name?'outline-double':'']" type="text" name="model" size="30"
              v-model="formdata.completeModelName"
              placeholder="Your search or autocomplete"
              aria-label="Search"
              autocomplete="off"

              @input="onChange"
              @keydown.down="onArrowDown"
              @keydown.up="onArrowUp"
              @keydown.enter="onEnter">&nbsp;
          <button class="btn btn-primary md:w-auto mt-2 md:mt-0" @click.stop="submitNavBarform()" type="submit">Search</button>
          <ul v-show="isAutoCompleteOpen" class="menu bg-gray-100 w-100 rounded-box absolute z-40">
              <li v-if="isLoadingModelNames == 'loading'" class="list-none text-left cursor-pointer hover:bg-violet-600 hover:text-white w-full p-2">Loading results...</li>
              <li
                v-else
                v-for="(result, i) in this.results"
                :key="i"
                @click="setResult(result)"
                :class="{ 'bg-violet-700 text-white': i === arrowCounter }"
                class="list-none text-left cursor-pointer hover:bg-violet-600 hover:text-white w-full p-2 italic font-sans"><span style="display:inline" v-html="result.completeModelName"></span></li>
            </ul>
        </form>
      </div>
    </nav>
  </header>
</template>


<script>
import axios from 'axios';

import {useUiElements} from "./../store/uiElements"
import { mapState, mapActions } from 'pinia'

export default {
  name: 'NavBar',

  data() {
    return {

      // needed for autocomplete algorithm
      results:[],
      isAutoCompleteOpen: false,
      arrowCounter: -1,
      isLoadingModelNames: '',
      timeout: null,
      formdata: {
          completeModelName: '',
          model_name: '',
          brand_name: '',
          marketing_name: ''
      },

      retrieveStatus: '', // display anim when busy retrieving data from server

      errors: [],
    }
  },


  computed: {
    ...mapState(useUiElements, {
        realBaseUrl: "realBaseUrl",
        auth: "baseRestApiAuth",
        deviceList: "deviceList",
        selectedDevice: "selectedDevice",
        availableCapabilities: "availableCapabilities",
    })

  },

  methods: {

    ...mapActions(useUiElements, ['setCurrentDeviceList', 'setAvailableCapabilities','setCurrentDeviceThroughREST']),

    submitNavBarform() {

      this.isAutoCompleteOpen = false

      this.errors = [];
      //console.log(this.formdata);

      // signal that we are waiting for data to be retrieved from server
      this.retrieveStatus = 'loading';
      // axios.post(`${useUiElements.baseUrl}/singleDevice`, this.formdata )

      // we have two possibilities.
      // 1. User selected one of the options offered by autofill => we opt for findByModelName
      // 2. User just goes for their own choice => we opt for findByGenericName

      let endpoint = `${this.realBaseUrl}/v1/devices/findByModelName?modelName=${this.formdata.model_name}&marketing_name=${this.formdata.marketing_name}&brandName=${this.formdata.brand_name}&expand=false`
      if (!this.formdata.model_name)
        endpoint = `${this.realBaseUrl}/v1/devices/findByGenericName?genericName=${this.formdata.completeModelName}`

      axios({
        method: 'get',
        url: endpoint,
        auth: this.auth
      })
      .then(res => {
        this.setCurrentDeviceList(res.data);
        this.retrieveStatus = '';
        // if the response contains devices, show the first one
        if (res.data.length >= 1) {
          let wid = res.data[0].wurfl_id
          if (wid) {
            this.setCurrentDeviceThroughREST(wid)
          }
        }
      })
      .catch(err => {
          // error
          this.retrieveStatus = '';
          console.log(err);
          this.errors.push(err)
      })
    },

    onChange() {

      // user has emptied the form. Let's reset the autofill machinery
      if (!this.formdata.completeModelName) {
        this.formdata.model_name = ''
        this.formdata.brand_name = ''
        this.formdata.marketing_name = ''
      }


      if (this.formdata.completeModelName.length < 3) {
        return
      }

      // user typed something and disregarded suggestion. Previous choice might be sticky. Reset
      this.formdata.model_name = ''
      this.formdata.brand_name = ''
      this.formdata.marketing_name = ''
      // we don't want to trigger an expensive method invocation too often. Debouncing
      // Adapted from: https://schier.co/blog/wait-for-user-to-stop-typing-using-javascript
      clearTimeout(this.timeout)
      // console.log("Timeout cleared")

      // wait for a moment before fetching suggestions. User might not be done typing yet
      this.timeout = setTimeout(fetchModelSuggestions, 500, this)

    },

    handleClickOutside(event) {
      this.isOpen = false
      this.arrowCounter = -1
      this.results = []
    },
    setResult(pick) {
      this.formdata = pick
      this.formdata.completeModelName = pick.completeModelName.replaceAll("<b>","").replaceAll("</b>","")
      this.isAutoCompleteOpen = false
      this.results = []
    },

    // Autocomplete suggestions: arrow key navigation
    onArrowDown() {
      if (this.arrowCounter < this.results.length -1) {
        this.arrowCounter = this.arrowCounter + 1
      } else {
        this.arrowCounter = 0
      }
    },

    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }  else {
        this.arrowCounter = this.results.length -1
      }
    },

    onEnter() {
      if (this.arrowCounter > -1) {
        this.formdata.completeModelName = this.results[this.arrowCounter].replaceAll("<b>","").replaceAll("</b>","")
        // console.log("arrowCounter is: " + this.results[this.arrowCounter])
      } else {
        console.log("Weird arrowCounter is: " + this.arrowCounter)
      }
      this.isAutoCompleteOpen = false
      this.arrowCounter = -1
    }

  },


  mounted() {
    // related to the autocomplete
    document.addEventListener('click', this.handleClickOutside)

    console.log(`Retrieving list of supported capas at ${this.realBaseUrl}/v1/capabilityNames`);
    axios({
      method: 'get',
      url: `${this.realBaseUrl}/v1/capabilityNames`,
      auth: this.auth
    })
    .then(res => {
      let capaList = res.data;

      this.setAvailableCapabilities(capaList);
    })
    .catch(err => {
        // error
        console.log(err);
        this.errors.push(err)
    })
  },
  unmounted() {
    document.removeEventListener('click', this.handleClickOutside)
  },
}


function highlightKey(mystr, replacement) {
  // highlight subsctring "topolino","topo" => "<b>topo</b>lino"

  if (!(typeof mystr === 'string' || mystr instanceof String)) {
    return ""
  }

  if (!mystr.toLowerCase().includes(replacement.toLowerCase())) {
    return mystr
  }
  // some escaping. We are turning a user-string into a RegEx after all: https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
  replacement = replacement.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  let reg = new RegExp(replacement, 'gi')
  // gotta love SO: https://stackoverflow.com/questions/3294576/javascript-highlight-substring-keeping-original-case-but-searching-in-case-inse
  // console.log(mystr.replace(reg,  '<b>$&</b>'))
  return mystr.replace(reg,  '<b>$&</b>')
}


function fetchModelSuggestions(componentdata) {

  componentdata.results = []
  componentdata.isLoadingModelNames = "loading"
  let key = componentdata.formdata.completeModelName

  axios({
    method: 'get',
    url: `${componentdata.realBaseUrl}/v1/devices/autofillBySubstring?key=${key}&maximum=10`,
    auth: componentdata.auth
  })
  .then(res => {
    let suggestions = res.data
    for (let i = 0; i < suggestions.length; i++) {
      let modelName = suggestions[i].model_name
      modelName = highlightKey(modelName,key)
      let marketingName = suggestions[i].marketing_name + ""
      marketingName = highlightKey(marketingName, key)
      let brandName = suggestions[i].brand_name
      brandName = highlightKey(brandName, key)
      let completeModelName = brandName +" " + modelName
      if (marketingName.trim().length > 0) {
        completeModelName += " (" + marketingName +")"
      }
      let deviceObj = { ...suggestions[i]} // spread operator to clone object
      deviceObj.completeModelName = completeModelName
      componentdata.results.push(deviceObj)
    }
    componentdata.isAutoCompleteOpen = true
    componentdata.isLoadingModelNames = ""
  })
  .catch(err => {
      // error
      console.log(err);
      // componentdata.errors.push(err)
  })

}

</script>

